module.exports = __webpack_public_path__ + "officialStatic/img/case9.a08e8b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case9.jpg
// module id = atsX
// module chunks = 0